import { FormControl, FormHelperText } from '@mui/material';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { Teams_Bool_Exp } from '@graphql/__generated__/graphql';
import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import { TeamsSelect } from '@modules/_shared/components/teams-select/TeamsSelect';
import { useLocale } from '@shared/hooks/locale';

export type RaTeamProps = {
  control: Control<any>;
  name: string;
  label: string;
  disabled?: boolean;
  required?: boolean;
  multiple?: boolean;
  filters?: Teams_Bool_Exp;
};

export const RaTeam = ({
  name,
  label,
  control,
  disabled = false,
  required,
  multiple = false,
  filters,
}: RaTeamProps) => {
  const { t } = useLocale();
  const rules = {
    required: required ? t('This field is required') : undefined,
  };
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <RaLabel label={label} required={required} />
          <TeamsSelect
            disabled={disabled}
            teamIds={value}
            onChange={teamIds => onChange(teamIds)}
            size="small"
            clearOnBlur={value == null}
            multiple={multiple}
            filters={filters}
          />
          {error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
